import React, { Fragment } from "react";

import { StyledUserMention, User } from "./style";

const mentionedUsersRegexCapture = /((.)\[([^[]*)]\(([^(^)]*)\))/gi;
const mentionedUsersRegex = /.\[[^[]*]\([^(^)]*\)/gi;

const UserMention = ({
  className,
  variant = "label3",
  fontSize = "14px",
  lineHeight = "20px",
  fontFamily = "var(--man-500)",
  content,
  onUserProfileClick,
}) => (
  <StyledUserMention
    variant={variant}
    fontSize={fontSize}
    lineHeight={lineHeight}
    fontFamily={fontFamily}
    className={className}
  >
    {content?.split(mentionedUsersRegex)?.map((str, index) => {
      const user = content?.match(mentionedUsersRegexCapture)?.[index - 1];
      const [, , trigger, userName, userId] =
        mentionedUsersRegexCapture?.exec(user) || [];
      return (
        <Fragment key={`${str}-${index}`}>
          {user && (
            <User
              variant="link2"
              fontSize={fontSize}
              lineHeight={lineHeight}
              fontFamily="var(--man-700)"
              onClick={() => onUserProfileClick(userId)}
            >
              {trigger}
              {userName}
            </User>
          )}
          {str}
        </Fragment>
      );
    })}
  </StyledUserMention>
);

export default UserMention;
